import { Injectable } from "@angular/core";
import { SessionManagerService } from "./SessionManager/session-manager.service";
import { ParentEventFromSearchWithSelectedChildEvents } from "../admin/events-screen/event-page-models/parent-event-from-search";
import { parentEventsMocks } from "../admin/events-screen/parent-events-mocks/parent-events.mock";
import { LocalStorageManagerService } from "./localStoageManager.service";
import { StoriesTypes } from "../development/stories/stories-types";
import { StoriesComponent } from "../development/stories/stories.component";

@Injectable()
export class DevToolsService {
  public mockParentEventsForSearch: ParentEventFromSearchWithSelectedChildEvents[] =
    [...parentEventsMocks.eventsWithChildrenMock].map((p, i) => {
      const childEventsWithSelected = p.childEvents.map((c) => {
        return { ...c, isSelected: true };
      });
      if (i === 2) {
        p.parentEventCode = "111111111";
        p.eventOpenTo =
          "מחוז חיפה, מחוז ירושליים, מחוז דרום, מחוז צפון, מחוז עמקים";
      }
      return { ...p, childEvents: childEventsWithSelected };
    });

  public devToolsEnabled: boolean = false;
  public viewedStories: StoriesTypes[] = [];
  constructor(
    private sessionManagerService: SessionManagerService,
    private localStorageManagerService: LocalStorageManagerService
  ) {
    if (this.localStorageManagerService.getItem("devToolsEnabled") === "true") {
      this.devToolsEnabled = true;
    }
    const viewedStories =
      this.localStorageManagerService.getItem("viewedStories");
    if (viewedStories) {
      this.viewedStories = JSON.parse(viewedStories) as StoriesTypes[];
    }
  }
  public static convertStoriesToLinks(
    stories: StoriesTypes[]
  ): Array<{ path: string; name: string; key: StoriesTypes }> {
    return stories.map((value) => {
      const pathName = DevToolsService.buildLinkName(value);
      return { path: value as string, name: pathName, key: value };
    });
  }
  public static buildLinkName = (link: StoriesTypes): string => {
    const storyType = (link as string) || "";

    return storyType
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  // public static
  public setDevToolsEnabled(enabled: boolean): void {
    this.devToolsEnabled = enabled;
    this.localStorageManagerService.setItem(
      "devToolsEnabled",
      this.devToolsEnabled ? "true" : "false"
    );
  }
  public clickedStory(story: StoriesTypes) {
    this.viewedStories.push(story);
    this.localStorageManagerService.setItem(
      "viewedStories",
      JSON.stringify(this.viewedStories)
    );
  }

  public removeStartsFromIsraeliId(israeliId: string): string {
    if (this.sessionManagerService.isDevOrStaging) {
      israeliId = (israeliId || "").replace(/[*]/g, "");
      //only first 9 digits are the real id
      israeliId = israeliId.substring(0, 9);
    }
    return israeliId;
  }

  public clearLastStories() {
    this.viewedStories = [];
    this.localStorageManagerService.removeItem("viewedStories");
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/dev-tools.service.ts